export const initialValues = {
  id: "",
  company_profile_id: "",
  company_profile_value: "",
  company_profile_value_french: "",
  company_profile_value_dutch: "",
  color_code: "#000000",
};
